export const MULTILINE_PREFIX = 'multiline:'
export const MULTILINE_SEPARATOR = '__'

export const getMultilineName = (name: string, index: number) =>
  MULTILINE_PREFIX + name + MULTILINE_SEPARATOR + index
